import { AxiosAdapter } from '../../../../../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getProducts(value) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/magistral-prepared?name=${value}&page=1&limit=10`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

}
